exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/users/edit-user/edit-user.component.css
// module id = ../../../../../angular/app/components/users/edit-user/edit-user.component.css
// module chunks = 1